
function BlockSlideDown(){

    const blocks = document.querySelectorAll('.block-slide-down');

    blocks.forEach( el => {
        let child = el.querySelector('.block-slide-down__inner');
        let editor = child.querySelector('.editor-text');
        let action = el.querySelector('.block-slide-down__action');

        if( editor.offsetHeight < 300 ){

            child.style.height = "auto";
            action.remove();

        }else{

            el.addEventListener('click', e => {
                el.classList.toggle("open");
                if ( child.offsetHeight == 300 ) {
                    gsap.to(child, 0.4, {height: 'auto'});
                }else{
                    gsap.to(child, 0.4, {height: 300});
                    el.scrollIntoView({behavior: "smooth"});
                }
            });

        }

    });

}